module.exports = __webpack_public_path__ + "static/media/choose-a-color.a513541e.png";